import { render, staticRenderFns } from "./BoxByFarmChart.vue?vue&type=template&id=82029288"
import script from "./BoxByFarmChart.vue?vue&type=script&lang=js"
export * from "./BoxByFarmChart.vue?vue&type=script&lang=js"
import style0 from "./BoxByFarmChart.vue?vue&type=style&index=0&id=82029288&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports